module.exports = __webpack_public_path__ + "img/horizontal_4_7_pp1_8019.792f8429.png";